<!-- @if (!sameMonth) { -->
<div class="d-flex justify-content-between align-items-baseline text-center card-container px-px-10 mt-px-10 flex-wrap">
  <h1 *ngIf="header" class="fs-24 fw-7 text-primary">{{ header }}</h1>

  <div class="d-flex mt-2" *ngIf="isCandidat">
    <app-button srcIcon="/assets/icons/plus.svg" class="me-1" text="Ajouter une non-disponibilité"
      (click)="openAddDisponibility()"></app-button>
      @if (showResetButton) {
  <app-button class="ms-2" [stroked]="true" text="Reset total des non-disponibilités"
    (click)="resetDate()"></app-button>
      }
 
  </div>

  <div class="d-flex align-items-center">
    <span class="fs-20 fw-4 text-primary">{{
      viewDate | calendarDate : view + "ViewTitle" : "fr"
      }}</span>
    <div class="col">
      <div class="d-flex align-items-center">
        <app-button text="Aujourd’hui" class="m-2" [stroked]="true" id="todayBtn" mwlCalendarToday
          [(viewDate)]="viewDate" (viewDateChange)="viewDate = $event; toDay($event)"></app-button>
        @if(sameMonth){
        <app-button text="" [disabled]="true" innerClass="disabled" class="me-2 disabled" [stroked]="true"
          srcIcon="/assets/icons/caret-arrow-left.svg"></app-button>
        }@else {
        <app-button text="" [stroked]="true" mwlCalendarPreviousView [view]="view" class="me-2"
          srcIcon="/assets/icons/caret-arrow-left.svg" [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay($event)"></app-button>
        }

        <app-button text="" [stroked]="true" mwlCalendarNextView srcIcon="/assets/icons/caret-arrow-right.svg"
          [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay($event)"></app-button>
      </div>
    </div>
  </div>
</div>

<br />
<div [ngSwitch]="view">
  <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [locale]="locale" [weekStartsOn]="1"
    (beforeViewRender)="ngOnInitDate($event)" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
    [cellTemplate]="monthCellTemplate" [activeDayIsOpen]="activeDayIsOpen"
    (eventClicked)="handleEvent('Clicked', $event)" (eventTimesChanged)="eventTimesChanged($event)">
  </mwl-calendar-month-view>
  
</div>
<ng-template #monthCellTemplate let-day="day" let-locale="locale">
  @if (actionBtn) {
  <div [matMenuTriggerFor]="menu" style="height: 70%">
    <mat-menu #menu="matMenu">
      <!-- <button mat-menu-item (click)="dayClicked(day, true)">
        <svg-icon src="/assets/icons/accept-disponibility.svg"></svg-icon>
        <span>Marquer comme disponible</span>
      </button> -->
      @if(day.cssClass != "cal-disabled")
      {
  <button mat-menu-item (click)="dayClicked(day, false)">
  <!-- <svg-icon src="/assets/icons/closed-disponibility.svg"></svg-icon>-->
    <span>Marquer comme Non disponible</span>
  </button>
      }
      @else{
          <button mat-menu-item (click)="dayClickedAvailable(day, false)">
            <span>Marquer comme disponible</span>
          </button>
      }
   
    </mat-menu>
    <div class="cal-month-view text-center" (click)="handleEvent('Clicked', day.events[0])">
      <span class="fs-16 fw-4 m-auto cursor-add" [ngClass]="{
          'text-secondary':
            (!isSameMonth(day.date, viewDate) ||
              day.cssClass == 'cal-disabled') &&
            !isSameDay(day.date, viewDate)
        }">{{ day.date | date : "d" }}</span>
      @for (event of day.events; track $index) {

      <div class="cal-month-event my-px-5" id="{{ event.id }}" [style.background]="event.color || backgroundColor"
        (mouseleave)="mouseLeaveEvent(event.id)" (mouseenter)="mouseEnterEvent(event.id)">
        <span class="fs-12 fw-4 tip" *ngIf="isSameDay(day?.date, event?.start)">{{
          event?.title +
          ", " +
          event?.etablissementNom +
          ", " +
          event?.site +
          ", " +
          event?.serviceAffectationsName
          }}</span>
        <div *ngIf="isSameDay(day?.date, event?.start)" class="event-cell">
          <span style="
              background: #00000033;
              border-radius: 4px 0px 0px 4px;
              height: 70px;
            ">{{ "&nbsp;&nbsp;" }}</span>
          <div class="d-flex flex-column align-items-baseline">
            <!--<span class="fs-12 fw-1">{{event?.title}}</span>-->
            <span class="fs-12 fw-1">{{event?.etablissementNom }}</span>
            <span class="fs-12 fw-1">{{event?.site }}</span>
            <span class="fs-12 fw-1">{{event?.serviceAffectationsName }}</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="cal-month-view text-center" (click)="handleEvent('Clicked', day.events[0])">
    <span class="fs-16 fw-4 m-auto" [ngClass]="{
        'text-secondary':
          (!isSameMonth(day.date, viewDate) ||
            day.cssClass == 'cal-disabled') &&
          !isSameDay(day.date, viewDate),
        'text-white': isSameDay(day.date, viewDate)
      }">{{ day.date | date : "d" }}</span>
    @for (event of day.events; track $index) {

    <div class="cal-month-event my-px-5" id="{{ event.id }}" [style.background]="event.color || backgroundColor"
      (mouseleave)="mouseLeaveEvent(event.id)" (mouseenter)="mouseEnterEvent(event.id)">
      <span class="fs-12 fw-4 tip" *ngIf="isSameDay(day?.date, event?.start)">{{
        event?.title +
        ", " +
        event?.etablissementNom +
        ", " +
        event?.site +
        ", " +
        event?.serviceAffectationsName
        }}</span>
      <div *ngIf="isSameDay(day?.date, event?.start)" class="event-cell">
        <span style="
            background: #00000033;
            border-radius: 4px 0px 0px 4px;
            height: 70px;
          ">{{ "&nbsp;&nbsp;" }}</span>
    <div class="d-flex flex-column align-items-start">
      <!--<span class="fs-12 fw-1">{{event?.title}}</span>-->
      <span class="fs-12 fw-1">{{event?.etablissementNom}}</span>
      <span class="fs-12 fw-1">{{event?.site}}</span>
      <span class="fs-12 fw-1">{{event?.serviceAffectationsName}}</span>
    </div>

      </div>

      <!-- <span>{{day.date | date : 'M/d/yyyy' }}</span>
            <span>{{  | date : 'M/d/yyyy' }}</span> -->
    </div>
    }
  </div>
  }
</ng-template>
<!-- Everything you see below is just for the demo, you don't need to include it in your app -->

<!-- <h3>
    Edit events
    <button class="btn btn-primary float-end" (click)="addEvent()">
      Add new
    </button>
    <div class="clearfix"></div>
  </h3>
   -->
<!-- <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Title</th>
          <th>Primary color</th>
          <th>Secondary + text color</th>
          <th>Starts at</th>
          <th>Ends at</th>
          <th>Remove</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let event of events">
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="event.title"
              (keyup)="refresh.next()"
            />
          </td>
          <td>
            <input
              type="color"
              [(ngModel)]="event.color.primary"
              (change)="refresh.next()"
            />
          </td>
          <td>
            <input
              type="color"
              [(ngModel)]="event.color.secondary"
              (change)="refresh.next()"
            />
            <input
              type="color"
              [ngModel]="event.color.secondaryText ?? '#1e90ff'"
              (ngModelChange)="event.color.secondaryText = $event"
              (change)="refresh.next()"
            />
          </td>
          <td>
            <input
              class="form-control"
              type="text"
              mwlFlatpickr
              [(ngModel)]="event.start"
              (ngModelChange)="refresh.next()"

              dateFormat="Y-m-dTH:i"
              altFormat="F j, Y H:i"
              placeholder="Not set"
            />
          </td>
          <td>
            <input
              class="form-control"
              type="text"
              mwlFlatpickr
              [(ngModel)]="event.end"
              (ngModelChange)="refresh.next()"

              dateFormat="Y-m-dTH:i"
              altFormat="F j, Y H:i"
              placeholder="Not set"
            />
          </td>
          <td>
            <button class="btn btn-danger" (click)="deleteEvent(event)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
   -->
<!-- <ng-template #modalContent let-close="close">
    <div class="modal-header">
      <h5 class="modal-title">Event action occurred</h5>
      <button type="button" class="close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        Action:
        <pre>{{ modalData?.action }}</pre>
      </div>
      <div>
        Event:
        <pre>{{ modalData?.event | json }}</pre>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">
        OK
      </button>
    </div>
  </ng-template> -->
<div class="my-2">
  <div style="color: rgba(77, 76, 76, 0.712)">
    Les jours grisés correspondent à vos non-disponibilités.
  </div>
  <div class="text-warning">Vous avez condidaté</div>
  <div style="color: #01a167">Mission confirmée et contrat signé</div>
</div>